var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_Meet-Logo.wine",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.921,
    height: 22.15,
    viewBox: "0 0 26.921 22.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_229402",
    "data-name": "Path 229402",
    d: "M49.5,24.521l2.624,3,3.529,2.255.615-5.236-.615-5.119-3.6,1.981Z",
    transform: "translate(-34.272 -13.446)",
    fill: "#00832d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229403",
    "data-name": "Path 229403",
    d: "M0,49.423v4.461a1.845,1.845,0,0,0,1.846,1.846H6.307l.923-3.372-.923-2.935L3.246,48.5Z",
    transform: "translate(0 -33.58)",
    fill: "#0066da"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229404",
    "data-name": "Path 229404",
    d: "M6.307,0,0,6.307l3.246.923,3.061-.923.908-2.895Z",
    fill: "#e94235"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229405",
    "data-name": "Path 229405",
    d: "M6.307,20.5H0v9.537H6.307Z",
    transform: "translate(0 -14.193)",
    fill: "#2684fc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229406",
    "data-name": "Path 229406",
    d: "M39.6,8.205l-4.03,3.3V21.864l4.048,3.319a.924.924,0,0,0,1.492-.729V8.919a.924.924,0,0,0-1.51-.714Zm-10.183,8.4v4.768H20.5v6.307H33.728a1.845,1.845,0,0,0,1.846-1.846V21.864Z",
    transform: "translate(-14.193 -5.535)",
    fill: "#00ac47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229407",
    "data-name": "Path 229407",
    d: "M33.728,0H20.5V6.307h8.921v4.768l6.153-5.1V1.846A1.845,1.845,0,0,0,33.728,0Z",
    transform: "translate(-14.193)",
    fill: "#ffba00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/google_meet.d7586d965a7fd3540c23326bd7f5a489.svg";
export { ForwardRef as ReactComponent };